export default "__VITE_ASSET__MHo_HK94__"